export default __webpack_public_path__ + "static/media/openapi_compass.f18af8dc.txt";